<template>
    <div class="form-wrapper">
        <v-form @submit="onSubmit" onSubmit="return false;">
            <v-container>
                <v-row>
                    <v-text-field
                            v-model="firstName"
                            :counter="30"
                            label="First Name"
                            required
                    ></v-text-field>

                </v-row>
                <v-row>
                    <v-text-field
                            v-model="lastName"
                            :counter="30"
                            label="Last Name"
                            required
                    ></v-text-field>

                </v-row>
                <v-row>
                    <v-text-field
                            v-model="nickName"
                            :counter="30"
                            label="Nickname"
                            required
                    ></v-text-field>

                </v-row>


            </v-container>
        </v-form>

    </div>
</template>

<script>

    import * as _ from "lodash";
    import {Component, Prop, Vue} from "vue-property-decorator";

    @Component({})
    export default class PersonForm extends Vue {

        get firstName() {
            return this.$store.state.selectedModel ?
                this.$store.state.selectedModel.firstName :
                null;
        }

        set firstName(value) {
            this.$store.dispatch("updateProperty", {propertyName: "firstName", value: value});

        }

        get nickName() {
            return this.$store.state.selectedModel ?
                this.$store.state.selectedModel.nickName :
                null;
        }

        set nickName(value) {
            this.$store.dispatch("updateProperty", {propertyName: "nickName", value: value});

        }

        get lastName() {
            return this.$store.state.selectedModel ?
                this.$store.state.selectedModel.lastName :
                null;
        }

        set lastName(value) {
            this.$store.dispatch("updateProperty", {propertyName: "lastName", value: value});

        }

        onSubmit(e) {
            return false;
        }

    }

</script>

<style scoped>
    .form-wrapper {
        margin: 10px;
    }
</style>
